import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';
import { IInspectionReport } from '../interfaces';

export type IGetInspectionReportRepoResponse = IRepoResponse<200, IInspectionReport> | IRepoResponse<400 | 500, string>;

export type IGetInspectionReportRepo = IRepo<[string], IGetInspectionReportRepoResponse>;

export const GetInspectionReportRepoType = Symbol.for('GetInspectionReportRepo');

@bind(GetInspectionReportRepoType)
export class GetInspectionReportRepo implements IGetInspectionReportRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker(`/api/admin/branch_inspections/${id}/report`) });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: result.data.data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Hesabat əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
